import apiClient from "@/shared/api/apiClient4";

export const StepRunList = async (notary_transaction_id, params) => {
  try {
    const { data } = await apiClient.get(
      `/step-runs-public/by-individual/${notary_transaction_id}/`,
      { params }
    );
    return data;
  } catch (e) {
    console.error("[step-runs] StepRunList", e);
    return { success: false, error: e?.message || String(e) };
  }
};

export const createStepRun = async (params) => {
  try {
    const { data } = await apiClient.post(
      `/step-runs-public/init/`,
      { ...params },
      { metaData: { isNotificationDisabled: true } }
    );
    return data;
  } catch (e) {
    console.error("[step-runs] createStepRun", e);
    return { success: false, error: e?.message || String(e) };
  }
};
